import { render, staticRenderFns } from "./CorporationSettingSocial.vue?vue&type=template&id=186a9098&"
import script from "./CorporationSettingSocial.vue?vue&type=script&lang=js&"
export * from "./CorporationSettingSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports